<p>trip-detention-screen works!</p>
